module.exports = __webpack_public_path__ + "files/96e23fd31e58b641b268092f61e0df2f.png";